import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../../shared/services/httpclient.service";
import { AddToGroupExistingRequest } from "./AddToGroupExistingRequest";
import { AddToGroupLoadPersonRequest } from "./AddToGroupLoadPersonRequest";
import { AddToGroupNewRequest } from "./AddToGroupNewRequest";

@Injectable()
export class DataService_AddToGroup {
	constructor(private httpclientService: HttpclientService) {}

	AddToGroupPersonSelectList(parms: AddToGroupLoadPersonRequest) {
		var postResult$ = new Subject();
		var url = "Groups/AddToGroupPersonSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	AddToGroupExisting(parms: AddToGroupExistingRequest) {
		var postResult$ = new Subject();
		var url = "Groups/AddToGroupExisting";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	AddToGroupNew(parms: AddToGroupNewRequest) {
		var postResult$ = new Subject();
		var url = "Groups/AddToGroupNew";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
